import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApprovalCheckResult, AutoApprovalResult, ExpenseApprovalSuggestionResult } from 'app/core/models/expense.model';
import { ExpenseService } from '../../../../core/services/expense.service';
import { AlertService } from '../../../../shared/alert/alert.service';
import { LogHelper } from 'app/core/helpers/log.helper';

@Component({
  selector: 'app-expense-approval-checks',
  templateUrl: './expense-approval-checks.component.html',
  styleUrls: ['./expense-approval-checks.component.scss']
})
export class ExpenseApprovalChecksComponent implements OnInit {
  @Input() result?: AutoApprovalResult;
  @Input() expenseClaimId: string;
  @Input() approvalCheckResults: ApprovalCheckResult[] = [];

  @Output() resultUpdated: EventEmitter<any> = new EventEmitter();

  loading = false;
  showModal = false;

  get passedCount(): number {
    return this.approvalCheckResults.filter(c => c.passed).length;
  }

  get failedCount(): number {
    return this.approvalCheckResults.filter(c => !c.passed).length;
  }

  get totalCount(): number {
    return this.approvalCheckResults.length;
  }

  get progressPercent(): number {
    return this.totalCount > 0 ? (this.passedCount / this.totalCount) * 100 : 0;
  }

  get sortedCheckResults(): ApprovalCheckResult[] {
    return [...this.approvalCheckResults].sort((a, b) =>
      Number(a.passed) - Number(b.passed) || Number(a.isAiCheck) - Number(b.isAiCheck)
    );
  }

  get stateClass(): string {
    switch (this.result) {
      case AutoApprovalResult.Approve: return 'state-approve';
      case AutoApprovalResult.Reject: return 'state-reject';
      default: return 'state-review';
    }
  }

  get stateIcon(): string {
    switch (this.result) {
      case AutoApprovalResult.Approve: return 'far fa-shield-check';
      case AutoApprovalResult.Reject: return 'far fa-shield-xmark';
      default: return 'far fa-shield-exclamation';
    }
  }

  get stateText(): string {
    switch (this.result) {
      case AutoApprovalResult.Approve: return 'Approve Claim';
      case AutoApprovalResult.Reject: return 'Reject Claim';
      default: return 'Manual Review';
    }
  }

  constructor(
    private expenseService: ExpenseService,
    private alertService: AlertService
  ) {}

  ngOnInit(): void {}

  recheck(): void {
    if (this.loading) return;

    this.loading = true;
    this.expenseService.suggestApproval(this.expenseClaimId).subscribe({
      next: (response: ExpenseApprovalSuggestionResult) => {
        this.result = response.autoApprovalResult;
        this.approvalCheckResults = response.approvalCheckResults ?? [];
        this.resultUpdated.emit(this.result);
        this.loading = false;
      },
      error: err => {
        LogHelper.log(err);
        this.alertService.showWarningAlert('Failed to run approval checks');
        this.loading = false;
      }
    });
  }

  openModal(): void {
    this.showModal = true;
  }

  closeModal(): void {
    this.showModal = false;
  }
}
